import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=669716a1&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('669716a1')) {
      api.createRecord('669716a1', component.options)
    } else {
      api.reload('669716a1', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=669716a1&", function () {
      api.rerender('669716a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/captain_bonuses/edit.vue"
export default component.exports